import { Validators } from "@angular/forms";

import { noSpecialCharactersValidator } from "./no-special-characters/no-special-characters.validator";
import { validationRegex } from "./validation.const";

export const COMMON_VALIDATORS = {
	zipCodeValidators: [
		Validators.maxLength(20),
		noSpecialCharactersValidator(validationRegex.noSpecialCharacters.generic),
	],
};
